'use client';

import type { EventBusListener } from '@hc-frontend/core-events';
import { useEventBus } from '@hc-frontend/core-ui';
import { trackComponentImpression } from '@hc-frontend/third-party-snowplow';
import { useCallback, useEffect } from 'react';

import type { ComponentImpressionEvent } from './component-impression-subscription.types';

export function ComponentImpressionSubscription() {
  const eventBus = useEventBus();

  const handleComponentImpression = useCallback<
    EventBusListener<ComponentImpressionEvent>
  >((event) => {
    trackComponentImpression(event.componentImpression, event.contexts);
  }, []);

  useEffect(() => {
    eventBus.subscribe(
      'core.ui.component.impression',
      handleComponentImpression,
    );

    return () => {
      eventBus.unsubscribe(
        'core.ui.component.impression',
        handleComponentImpression,
      );
    };
  }, [eventBus, handleComponentImpression]);

  return null;
}
